import React from 'react';
import { useSelector } from 'react-redux';
import { getCountryCode, getFlagUrl } from '../../../SysGuard/Dashboard/ContentPages/SysGuardColumnConfig';
import { dataguard_icons } from '../../../../components/common/utilities';
import { isNull, isUndefined } from 'lodash';

/**
 * Common header component for user location popups
 */
const UserLocationHeader = ({ 
  popupData, 
  location, 
  city,
  isIncognito = false,
  title = "Location - Users",
  subHeading = "Activities:",
  showCountryFlag = true
}) => {

  const popupDetails = useSelector((state) => state.DataguardReducer.popupDetails);
  const renderCountryNameWithFlag = (country, city) => {
    const code = getCountryCode(country);
    let flagUrl = "/sysGuardIcons/unknownFlag.svg";
    if (code && code !== "Unknown" && code !== "Not Found") {
      flagUrl = getFlagUrl(code);
    }
    return (
      <>
        {flagUrl && country !== "Unknown" ? (
          <div className="country-with-flag">
            <img src={flagUrl} alt={country} className="country-flag Title" />
            <span className="second-title">{!isNull(city) && !isUndefined(city) ? `${city}, ${country}` : country}</span>
          </div>
        ) : (
          <div className="country-with-flag">
            <img src={"/sysGuardIcons/unknownFlag.svg"} alt={"Unknown"} className="country-flag Title" />
            <span className="second-title">{!isNull(city) && !isUndefined(city) ? `${city}, ${country}` : country}</span>
          </div>
        )}
      </>
    );
  };

  const renderTitleNumberClasses = () => {
    return "sys-guard-location nonAnomalies";
  };

  const renderTitleNumber = (popupData) => popupData?.totalElements ?? 0;
  // Check if this is a child-level popup and has datasource details
  const isChildLevel = popupDetails?.isChildLevel || false;
  const dataSourceDetails = popupDetails?.dataSourceDetails;

  return (
    <div className="user-location-left-panel">
      <div className="header-title">
        {title}
        {isChildLevel && dataSourceDetails && (
        <div className="datasource-header-line">
          <img
            className="ds-icon"
            title={dataSourceDetails.dataSourceType}
            src={dataguard_icons[dataSourceDetails.dataSourceType]}
            alt={dataSourceDetails.dataSourceType}
          />
          <div className="ds-name">{dataSourceDetails.dataSourceName}</div>
        </div>
      )}
      </div>
      <div className="second-title-container">
        {showCountryFlag ? (
          renderCountryNameWithFlag(location, city)
        ) : (
          <span className="second-title">{popupDetails?.subtitleDisplayName || ''}</span>
        )}
        <span className="header-title-bracket"> {`( `} </span>
        <span className={renderTitleNumberClasses()}>
          {subHeading} {renderTitleNumber(popupData)}
        </span>
        <span className="header-title-bracket">)</span>
      </div>
    </div>
  );
};

export default UserLocationHeader;